export const styles = {
  container:
    "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-800 rounded-lg p-4 relative before:absolute before:left-0 before:right-0 before:top-[60px] before:h-[1px] before:bg-gray-100 dark:before:bg-gray-700",
  header: "px-0 py-0",
  title: "pb-2 text-xl font-semibold text-gray-800 dark:text-white/90",
  formContainer: "bg-white dark:bg-gray-800 rounded-lg mt-8 min-h-[450px]",
  form: "grid grid-cols-1 md:grid-cols-4 gap-4 items-start", // Updated to match UserAdd's 4-column layout
  profileImageSection: "col-span-1 flex flex-col items-start",
  label: "text-sm font-medium text-gray-800 dark:text-white/90 mb-1 block",
  loadingText: "text-gray-800 dark:text-white/90 text-center mt-4",
  rolesContainer: "w-full",
  userDetails: "col-span-3 grid grid-cols-1 md:grid-cols-3 gap-x-3 gap-y-3", // Updated to match UserAdd's 3-column user details
  inputField:
    "h-11 w-full rounded-lg border appearance-none px-4 py-2.5 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 bg-transparent text-gray-800 border-gray-300 dark:border-gray-600 focus:border-brand-300 dark:focus:border-brand-800 focus:ring-brand-500/10",
  inputError:
    "border-red-400 ring-2 ring-red-500/10 dark:border-red-400 dark:ring-2 dark:ring-red-500/10",
  inputValid: "border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-500/10",
  inputDefault:
    "border-gray-300 dark:border-gray-600 focus:border-brand-300 dark:focus:border-brand-800 focus:ring focus:ring-brand-500/10",
  errorText: "text-red-500 dark:text-red-400 text-xs mt-1",
  rolesSection: "col-span-1",
  radioGroup: "flex flex-row gap-2", // Added to match UserAdd
  radioLabel: "flex items-center gap-2 text-sm text-gray-800 dark:text-white/90", // Added to match UserAdd
  radioInput: "h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500", // Added to match UserAdd
  buttonsContainer:
    "col-span-1 md:col-span-4 p-9 flex flex-row justify-end gap-2 w-full", // Updated to match UserAdd
  submitButton:
    "px-8 py-2 text-sm bg-[#2f6aa7] dark:bg-[#3d6794] text-white rounded-lg hover:bg-[#2779bd] dark:hover:bg-[#335877] w-auto",
  cancelButton:
    "px-4 py-2 text-sm bg-white text-gray-700 ring-1 ring-gray-300 rounded-lg hover:bg-gray-50 dark:bg-gray-900 dark:text-gray-400 dark:ring-gray-700 w-auto",
  required: "text-error-500 dark:text-red-400",
  modal:
    "w-[80%] max-w-[400px] bg-white dark:bg-gray-900 px-6 py-6 rounded-lg shadow-xl mx-auto text-center relative",
  modalCloseButton:
    "absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200",
  modalIconContainer:
    "w-14 h-14 flex items-center justify-center bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-400 rounded-full mx-auto",
  modalTitle: "text-lg font-bold text-gray-800 dark:text-white mt-4",
  modalMessage: "text-sm text-gray-500 dark:text-gray-400 mt-2",
  modalButtonContainer: "mt-4 flex justify-center",
  modalButton:
    "px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 dark:bg-green-700 dark:hover:bg-green-600",
};